<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:new="newHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import PayoutControlForm from "../../../components/payroll/payoutcontrol/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": PayoutControlForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      loading: true,
      formData: [],
      pageTitle: this.$t('payrollprocessrun.editpayoutcontrol'),
      pageTitleValue: "",
      errMsg: "",
      isErr: false,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      if (this.formData.allowinput == true) {
        this.formData.allowinput = 1;
      } else {
        this.formData.allowinput = 0;
      }

      if (this.formData.ssrel == true) {
        this.formData.ssrel = 1;
      } else {
        this.formData.ssrel = 0;
      }

      this.$store.dispatch('put', {url: "/payoutctrl/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payoutcontrollist" , params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/payoutctrl/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payoutcontrollist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    newHandler() {
      this.$router.push({ name: "payoutcontrolnew" });
    },

    loadPayoutControl() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/payoutctrl/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          if (res.data.rec[0].startdate) {
            vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].enddate) {
            vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

          if (vm.formData.allowinput == "Y") {
            vm.formData.allowinput = true;
          } else {
            vm.formData.allowinput = false;
          }

          if (vm.formData.ssrel == "Y") {
            vm.formData.ssrel = true;
          } else {
            vm.formData.ssrel = false;
          }

          vm.pageTitleValue = vm.formData.payoutdesc;
          vm.formData.userid = this.$store.getters.userId;

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadPayoutControl();
  },
};
</script>

<style scoped>
</style>